import { useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import "./NavAccordionMenu.scss";

const NavAccordionMenu = ({ menuLink, id, onClick }) => {
  const [expand, setExpand] = useState(false);

  let match = useRouteMatch({
    path: `/${menuLink.slug}`,
    exact: false,
  });

  const handleAccordion = () => {
    setExpand((current) => !current);
  };

  return (
    <div
      id={id + "-accordion-menu__container"}
      className="accordion-menu__container"
      onClick={handleAccordion}
    >
      <li
        className="mobile-nav-links__accordion-item"
        data-for={id + "-accordion-menu"}
        id={id + "-accordion-menu"}
        data-tip
      >
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <span className={match ? "active" : ""} aria-label={menuLink.name}>
          {menuLink.name}
          {expand ? (
            <ExpandLessIcon className="arrow-icon" />
          ) : (
            <ExpandMoreIcon className="arrow-icon" />
          )}
        </span>
      </li>
      {expand && (
        <div className="accordion-menu">
          <ul>
            {menuLink.links.map((x) => {
              return (
                <li key={x.name} className="accordion-menu__links">
                  <NavLink
                    to={`/${x.path}`}
                    exact={x.exact}
                    aria-label={`visit ${x.name} page`}
                    onClick={onClick}
                  >
                    {x.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NavAccordionMenu;
